import { Global, keyframes } from "@emotion/core";
import type { ReactNode, RefObject } from "react";
import { Component, createRef } from "react";
import Spinner from "spin.js";

type Position = "absolute" | "fixed";

interface Props {
  isLoaded: boolean;
  color?: string;
  children?: Array<ReactNode> | ReactNode;
  position?: Position;
  scale?: number;
  top?: string;
  left?: string;
  className?: string;
}

// Simple wrapper for spin.js (http://spin.js.org/)
export class LoadingIndicator extends Component<Props> {
  private readonly el: RefObject<HTMLDivElement>;
  private readonly spinnerAnimation: any;

  static get defaultProps() {
    return {
      className: "loader",
      position: "absolute" as Position,
      color: "#878D94",
      scale: 1.0,
      top: "50%",
      left: "50%",
    };
  }

  constructor(props: Props) {
    super(props);
    this.el = createRef();

    // Translated from spinner-line-fade-default in http://spin.js.org/spin.css
    this.spinnerAnimation = keyframes`
      0%,
      100% {
        opacity: 0.22; /* minimum opacity */
      }
      1% {
        opacity: 1;
      }
    `;
  }

  setSpinner() {
    if (this.el.current === null) {
      return;
    }
    const spinner = new Spinner({
      "color": this.props.color,
      "position": this.props.position,
      "lines": 10,
      "length": 9,
      "width": 8,
      "radius": 16,
      "speed": 1.2,
      "scale": this.props.scale,
      "top": this.props.top,
      "left": this.props.left,
      "animation": this.spinnerAnimation.name,
    });
    spinner.spin(this.el.current);
  }

  componentDidMount() {
    this.setSpinner();
  }

  componentDidUpdate() {
    this.setSpinner();
  }

  render() {
    if (this.props.isLoaded) {
      return (
        <div className="loadedContent" key="content">
          {this.props.children}
        </div>
      );
    } else {
      return (
        <div className={this.props.className} key="loader" ref={this.el}>
          <Global styles={this.spinnerAnimation}></Global>
        </div>
      );
    }
  }
}
